//#region src/i9n_item_ref_sort_fields.ts
var I9nItemRefSortFields = /* @__PURE__ */ function(I9nItemRefSortFields) {
	I9nItemRefSortFields[I9nItemRefSortFields["Uncategorized"] = 0] = "Uncategorized";
	I9nItemRefSortFields[I9nItemRefSortFields["NameStartsWith"] = 1] = "NameStartsWith";
	I9nItemRefSortFields[I9nItemRefSortFields["SelectedByDefault"] = 2] = "SelectedByDefault";
	return I9nItemRefSortFields;
}(I9nItemRefSortFields || {});
//#endregion
export { I9nItemRefSortFields };

//# sourceMappingURL=i9n_item_ref_sort_fields.js.map